import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const TimestampConverter = () => {
  const { isAuthenticated } = useAuth();
  const [timestamp, setTimestamp] = useState('');
  const [date, setDate] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleConvert = async () => {
    if (!timestamp && !date) {
      setError('Please enter timestamp or date');
      return;
    }

    try {
      setError('');
      const response = await api.post('/api/utilities/timestamp/convert', {
        timestamp: timestamp ? parseInt(timestamp) : null,
        date: date || null
      });
      setResult(response.data);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to convert');
        setResult(null);
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>Timestamp Converter</h1>
        <div className="utility-form">
          <div className="input-section">
            <label>Unix Timestamp</label>
            <input
              type="number"
              value={timestamp}
              onChange={(e) => { setTimestamp(e.target.value); setDate(''); }}
              placeholder="e.g., 1609459200"
            />
          </div>
          <div style={{ textAlign: 'center', margin: '1rem 0' }}>OR</div>
          <div className="input-section">
            <label>Date (ISO format)</label>
            <input
              type="text"
              value={date}
              onChange={(e) => { setDate(e.target.value); setTimestamp(''); }}
              placeholder="e.g., 2021-01-01T00:00:00"
            />
          </div>
          <button onClick={handleConvert} className="btn-process">Convert</button>
          {error && <div className="error-message">{error}</div>}
          {result && (
            <div className="output-section">
              <label>Result</label>
              <div className="result-display">
                <div><strong>Timestamp:</strong> {result.timestamp}</div>
                <div><strong>Date:</strong> {result.date}</div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default TimestampConverter;

